/* ============================================================================
   Night Operators PVS-14 upsell for the PREDATOR kit selector (assets/pvs14-upsell.js)
   Branch PVS14-UPSELL, 2026-09-04. No framework, no build step, edits NOTHING in
   assets/predator-kit.js. Loaded (defer) by the pvs14-upsell liquid row, which
   sits inside #no-predator-kit .no-pk__addons.

   HOOK CONTRACT with predator-kit.js (window.NOPredatorKit), all read-only:
     1. CART LINE. predator-kit.js dispatches `no-predator:adding` on document
        with detail = the payload object, synchronously, BEFORE it calls
        JSON.stringify(payload) for fetch('/cart/add.js'). This module listens and,
        when the PVS-14 is selected, pushes {id: <variant>, quantity: 1} onto
        detail.items. Every press that goes through NOPredatorKit.addToCart (the
        theme button, the kit ADD THIS KIT button, the lander buy box and IN THE
        BOX buttons) therefore carries the PVS-14 as one more line in the SAME
        single /cart/add.js call. Nothing is sent twice.
     2. PRICE ON TOP. NOPredatorKit.subscribe(fn) runs fn after the kit's own
        subscribers (registration order), so this module rewrites the kit summary
        total / compare and the theme price block to kit + PVS-14 when selected,
        and lets the kit's own figures stand when not.
     3. READ-OUTS for anyone else (main, the lander): window.NOPvs14Upsell,
        the `no-pvs14:change` document event (detail = get()), and the
        data-no-pvs14-selected / data-no-pvs14-variant / -housing / -fom
        attributes on #no-pvs14-upsell.
   Prices are USD constants, the same convention predator-kit.js uses for the
   kit and add-ons (source: adset-profit-share.md, PVS-14 KIT rows). Variant ids
   are the live Shopify ids from the Lovable SHOPIFY_VARIANT_MAP.
   ========================================================================== */
(function () {
  'use strict';
  if (window.NOPvs14Upsell) return;

  /* ---------------------------------------------------------------- facts */
  var HOUSINGS = ['STANDARD', 'PRO'];
  var FOMS = ['1250-1350', '1400-1550', '1600-1750', '1800-2000'];
  var VARIANTS = {
    STANDARD: { '1400-1550': 50748972531958, '1600-1750': 50861859799286, '1800-2000': 50748972564726 },
    PRO:      { '1250-1350': 50652605907190, '1400-1550': 50748972663030, '1600-1750': 50861859864822, '1800-2000': 50748972695798 }
  };
  var PRICES = {
    STANDARD: { '1400-1550': 1849.95, '1600-1750': 2299.95, '1800-2000': 2449.95 },
    PRO:      { '1250-1350': 1784.95, '1400-1550': 1884.95, '1600-1750': 2334.95, '1800-2000': 2484.95 }
  };

  /* ---------------------------------------------------------------- helpers */
  function fmt(n) {
    var k = window.NOPredatorKit;
    if (k && typeof k.fmt === 'function') return k.fmt(n);
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function fmtWhole(n) {
    var k = window.NOPredatorKit;
    if (k && typeof k.fmtWhole === 'function') return k.fmtWhole(n);
    var whole = Math.abs(n - Math.round(n)) < 0.005;
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 });
  }
  function r2(n) { return Math.round(n * 100) / 100; }
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------------------------------------------------------------- state */
  /* 2026-09-04 main, Bon: the few remaining PRO 1250-1350 units must disappear when stock runs out. The snippet
     prints Shopify's live variant availability in data-no-p14-avail (id:true,...); an unavailable variant is
     treated like a missing one: pill hidden, selection moves. */
  var AVAIL = null;
  function availOf(id) {
    if (AVAIL === null) {
      AVAIL = {};
      var r = document.getElementById('no-pvs14-upsell');
      var raw = r ? (r.getAttribute('data-no-p14-avail') || '') : '';
      raw.split(',').forEach(function (pair) { var kv = pair.split(':'); if (kv[0]) AVAIL[kv[0].trim()] = kv[1] !== 'false'; });
    }
    return AVAIL[String(id)] !== false;
  }
  function sells(h, f) { var id = VARIANTS[h] && VARIANTS[h][f]; return !!id && availOf(id); }
  var state = { selected: false, housing: 'STANDARD', fom: '1400-1550' };
  var subs = [];
  function variantId(s) { s = s || state; return VARIANTS[s.housing][s.fom]; }
  function price(s) { s = s || state; return PRICES[s.housing][s.fom]; }
  function label(s) { s = s || state; return 'PVS-14 ' + s.housing + ' ' + s.fom; }
  function get() {
    return { selected: state.selected, housing: state.housing, fom: state.fom, variantId: variantId(), price: price(), label: label() };
  }
  function item() { return state.selected ? { id: variantId(), quantity: 1 } : null; }
  function emit() {
    var s = get();
    for (var i = 0; i < subs.length; i++) { try { subs[i](s); } catch (e) { if (window.console) console.error('[no-pvs14] subscriber', e); } }
    try { document.dispatchEvent(new CustomEvent('no-pvs14:change', { detail: s })); } catch (e) {}
  }
  function set(on) { on = !!on; if (state.selected === on) return; state.selected = on; emit(); }
  function toggle() { set(!state.selected); }
  /* 2026-09-04 main: the store has no STANDARD 1250-1350 variant (the Lovable map was stale, the cart answered 422), so a housing change lands on the first FOM that housing really sells. */
  function setHousing(h) { if (HOUSINGS.indexOf(h) < 0 || state.housing === h) return; state.housing = h; if (!sells(h, state.fom)) state.fom = FOMS.filter(function (f) { return sells(h, f); })[0] || state.fom; emit(); }
  function setFom(f) { if (FOMS.indexOf(f) < 0 || state.fom === f || !sells(state.housing, f)) return; state.fom = f; emit(); }

  var api = window.NOPvs14Upsell = {
    HOUSINGS: HOUSINGS, FOMS: FOMS, VARIANTS: VARIANTS, PRICES: PRICES,
    get: get, set: set, toggle: toggle, setHousing: setHousing, setFom: setFom,
    variantId: function () { return variantId(); }, price: function () { return price(); }, label: function () { return label(); }, item: item,
    subscribe: function (fn) { subs.push(fn); fn(get()); return function () { var i = subs.indexOf(fn); if (i >= 0) subs.splice(i, 1); }; }
  };

  /* ---------------------------------------------------------------- HOOK 1: the cart line */
  document.addEventListener('no-predator:adding', function (ev) {
    if (!state.selected) return;
    var p = ev && ev.detail;
    if (!p || !p.items || typeof p.items.push !== 'function') return;
    var id = variantId();
    for (var i = 0; i < p.items.length; i++) { if (Number(p.items[i].id) === id) return; }
    p.items.push({ id: id, quantity: 1 });
  });

  /* ---------------------------------------------------------------- DOM */
  function settleFom() { if (!sells(state.housing, state.fom)) { var f = FOMS.filter(function (x) { return sells(state.housing, x); })[0]; if (f) state.fom = f; } }
  function bindRow() {
    settleFom();
    var root = document.getElementById('no-pvs14-upsell');
    if (!root || root.hasAttribute('data-no-bound')) return root;
    root.setAttribute('data-no-bound', '1');

    var row = $('[data-no-p14-row]', root);
    var input = $('[data-no-p14-toggle]', root);
    var panel = $('[data-no-p14-panel]', root);
    var priceEl = $('[data-no-p14-price]', root);
    var lineEl = $('[data-no-p14-line]', root);
    var hero = $('[data-no-p14-hero]', root);
    var views = $$('[data-no-p14-view]', root);
    var hPills = $$('[data-no-p14-h]', root);
    var fPills = $$('[data-no-p14-f]', root);

    if (input) input.addEventListener('change', function () { api.set(input.checked); });
    hPills.forEach(function (b) { b.addEventListener('click', function (ev) { ev.preventDefault(); api.setHousing(b.getAttribute('data-no-p14-h')); }); });
    fPills.forEach(function (b) { b.addEventListener('click', function (ev) { ev.preventDefault(); api.setFom(b.getAttribute('data-no-p14-f')); }); });
    views.forEach(function (b) {
      b.addEventListener('click', function (ev) {
        ev.preventDefault();
        var src = b.getAttribute('data-no-p14-view');
        if (hero && src) hero.src = src;
        views.forEach(function (v) { v.classList.toggle('is-on', v === b); });
      });
    });

    api.subscribe(function (s) {
      root.setAttribute('data-no-pvs14-selected', s.selected ? '1' : '0');
      root.setAttribute('data-no-pvs14-variant', s.selected ? String(s.variantId) : '');
      root.setAttribute('data-no-pvs14-housing', s.housing);
      root.setAttribute('data-no-pvs14-fom', s.fom);
      if (input) input.checked = s.selected;
      if (row) row.classList.toggle('is-on', s.selected);
      if (panel) panel.hidden = !s.selected;
      if (priceEl) priceEl.textContent = '+ ' + fmt(s.price);
      if (lineEl) lineEl.textContent = 'PVS-14 ' + s.housing + ' · FOM ' + s.fom + ' · + ' + fmt(s.price);
      hPills.forEach(function (b) { var on = b.getAttribute('data-no-p14-h') === s.housing; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      fPills.forEach(function (b) { var on = b.getAttribute('data-no-p14-f') === s.fom; b.hidden = !sells(s.housing, b.getAttribute('data-no-p14-f')); b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    });
    return root;
  }

  /* ---------------------------------------------------------------- HOOK 2: price on top */
  function bindKit() {
    var kit = window.NOPredatorKit;
    if (!kit || typeof kit.subscribe !== 'function' || bindKit.done) return !!bindKit.done;
    bindKit.done = true;
    var root = document.getElementById('no-pvs14-upsell');
    var kitRoot = document.getElementById('no-predator-kit');
    var totalEl = kitRoot ? $('[data-no-pk-total]', kitRoot) : null;
    var compareEl = kitRoot ? $('[data-no-pk-compare]', kitRoot) : null;
    var saveEl = kitRoot ? $('[data-no-pk-save]', kitRoot) : null;
    var lineTotal = root ? $('[data-no-p14-total]', root) : null;
    var info = (kitRoot && (kitRoot.closest('.product__info-container') || kitRoot.closest('[id^="ProductInfo-"]'))) || document;
    var priceBox = $('[id^="price-"]', info);
    var lastKit = null;

    function render() {
      var k = lastKit || kit.get();
      var p = state.selected ? price() : 0;
      var total = r2(k.price + p);
      var compare = r2(k.compare + p);
      if (totalEl) totalEl.textContent = fmt(total);
      if (compareEl) compareEl.textContent = fmt(compare);
      if (saveEl) saveEl.textContent = 'SAVE ' + fmtWhole(r2(compare - total));
      if (priceBox) {
        $$('.price__sale .price-item--sale, .price__regular .price-item--regular', priceBox).forEach(function (el) { el.textContent = fmt(total); });
        $$('.price__compare-price s, .price__compare-price .price-item--regular', priceBox).forEach(function (el) { el.textContent = fmt(compare); });
        $$('.price__badge-sale .nowrap', priceBox).forEach(function (el) { el.textContent = 'SAVE $' + Math.round(compare - total).toLocaleString('en-US'); /* 2026-09-04 main: the kit helper returned an empty string here on the live page */ });
      }
      if (lineTotal) {
        lineTotal.hidden = !state.selected;
        lineTotal.textContent = state.selected ? (k.name + ' ' + fmt(k.price) + ' + PVS-14 ' + fmt(p) + ' = ' + fmt(total)) : '';
      }
    }
    // runs after the kit's own subscribers (registered earlier), so the rewrite wins
    kit.subscribe(function (k) { lastKit = k; render(); });
    api.subscribe(function () { if (lastKit) render(); });
    return true;
  }

  /* CART-FIX-1028: the price shown is the LIVE price of the exact variant that would go in the cart (read from
     /products/pvs-14-night-vision-monocular.js as this visitor), never the typed table above, which only stays as
     the first paint. Until the shopper picks a tier, the row starts on the lowest priced tier in stock (PRO 1250
     at $1,784.95 on 28 Oct) instead of STANDARD 1400 ($1,849.95). The Halloween $50 off is NOT shown here: the
     PREDATOR kit's own free bridge and lens offer does not combine with it, so with a PREDATOR in the cart the
     PVS-14 rings its full price (real cart, 28 Oct). */
  var touched = false;
  ['set', 'setHousing', 'setFom', 'toggle'].forEach(function (k) {
    var f = api[k];
    api[k] = function () { touched = true; return f.apply(this, arguments); };
  });
  function liveRead() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'products/pvs-14-night-vision-monocular.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('pvs14 ' + r.status); return r.json(); })
      .then(function (d) {
        var byId = {};
        (d.variants || []).forEach(function (v) { byId[v.id] = v; });
        availOf(0);
        var best = null;
        HOUSINGS.forEach(function (h) {
          FOMS.forEach(function (f) {
            var id = VARIANTS[h][f], v = id && byId[id];
            if (!id) return;
            if (!v) { AVAIL[String(id)] = false; return; }
            PRICES[h][f] = v.price / 100;
            AVAIL[String(id)] = !!v.available;
            if (v.available && (!best || v.price < best.p)) best = { h: h, f: f, p: v.price };
          });
        });
        if (!touched && !state.selected && best) { state.housing = best.h; state.fom = best.f; }
        settleFom();
        emit();
      })
      .catch(function () { /* keep the first paint */ });
  }

  function init() {
    liveRead();
    bindRow();
    if (!bindKit()) {
      // predator-kit.js is deferred too; wait for it (up to 15 s), then bind once
      var tries = 0;
      var t = setInterval(function () { if (bindKit() || ++tries > 150) clearInterval(t); }, 100);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { bindRow(); });
}());
